function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-text-phe");

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("text", {
  id: "text-1",
  fontFamily: "IBMPlexSans-Bold, IBM Plex Sans",
  fontSize: 16,
  fontWeight: "bold",
  fill: "#3D6DCC"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 5,
  y: 21
}, "Aa")), /*#__PURE__*/React.createElement("filter", {
  x: "-6.0%",
  y: "-6.2%",
  width: "119.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-text-phe",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Aa-Copy-2"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3D6DCC",
  fillOpacity: 1,
  strokeOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#text-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#3D6DCC",
  fillOpacity: 1,
  strokeOpacity: 1,
  xlinkHref: "#text-1"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#text-1"
}))));

const SvgIco30TextPhe = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30TextPhe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-text-phe.a3a894ee.svg";
export { ForwardRef as ReactComponent };